export default class templateImagesBlockPart {
    constructor() {
        return {
            restrict: 'E',
            scope: {
                'imageId': '=',
                'messages': '&',
                'type': '@'
            },
            template: require('../../../../views/template/template-images-block-part.html'),
            controller: ImageBlockPartCtrl,
            controllerAs: 'part'
        }
    };
};

class ImageBlockPartCtrl {
    constructor($scope, ImageBank, SweetAlert) {
        this._scope = $scope;

        this.alerter = SweetAlert;
        
        this.croppedImageFile = null;
        this.imageFile = null;

        this._scope.$watch(() => this._scope.imageId, (newVal, oldVal) => {
            if (newVal) {
                ImageBank.get(newVal).then((result) => {
                    this.image = result.image;
                    this.imageUrl = result.publicS3Path + '/' + this.image.data.filename;
                });
            }
        });

        this._scope.$watch(() => this.imageFile, (newVal, oldVal) => {
            if (newVal && newVal != oldVal) {
                this.showPrompt(true);
            }
        });

        this._scope.$watch(() => this.croppedImageFile, (newVal, oldVal) => {
            if (newVal && newVal != oldVal) {
                this.showPrompt(false);
            }
        });
    }
    
    test() {
        console.log("tst");   
    }

    getFileName() {
        return this._scope.type + "File";
    };

    updateImage(useOriginal) {
        var image = useOriginal ? this.imageFile : this.croppedImageFile;
        this._scope.$emit('template:images:imageUpdated', image, this._scope.type, useOriginal);
    };

    showPrompt(useOriginal) {
        this.alerter.swal({
            title: this._scope.messages().dialog_header,
            text: this._scope.messages().dialog_info,
            type: "warning",
            showCancelButton: true
        }, (isConfirmed) => {
            if (isConfirmed) {
                this.updateImage(useOriginal);
            }
        });
    };
}